import * as yup from "yup";

export const LoginSchema = yup.object().shape({
	email: yup.string().email('Invalid email').required("Email is required"),
	password: yup.string().required("Password is required").max(18, "Max  length 18 characters"),
});
